"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFarmByStakedLPFactory = exports.STAKED_LP_FACTORY = exports.hrFarms = exports.Farms = void 0;
const types_1 = require("./types");
var Farms;
(function (Farms) {
    Farms["quickswapOld"] = "quickswapOld";
    Farms["quickswap"] = "quickswap";
    Farms["quickswapDual"] = "quickswapDual";
    Farms["satin"] = "satin";
    Farms["pearl"] = "pearl";
    Farms["pearlStable"] = "pearlStable";
    Farms["sushiswap"] = "sushiswap";
    Farms["arbinyan"] = "arbinyan";
    Farms["swapr"] = "swapr";
    Farms["swapfish"] = "swapfish";
    Farms["zyberswap"] = "zyberswap";
    Farms["arbidex"] = "arbidex";
    Farms["solidlizard"] = "solidlizard";
    Farms["ramses"] = "ramses";
    Farms["auragi"] = "auragi";
    Farms["chronos"] = "chronos";
    Farms["solunea"] = "solunea";
    Farms["velocimeter"] = "velocimeter";
    Farms["velocore"] = "velocore";
    Farms["draculafi"] = "draculafi";
    Farms["vesync"] = "vesync";
    Farms["radiant"] = "";
    Farms["plutusDao"] = "plutusdao";
    Farms["pangolin"] = "pangolin";
    Farms["pangolinV2"] = "pangolinV2";
    Farms["traderJoeV2"] = "traderJoeV2";
    Farms["traderJoeV3"] = "traderJoeV3";
    Farms["traderJoeV4"] = "traderJoeV4";
    Farms["flair"] = "flair";
    Farms["glacier"] = "glacier";
    Farms["solarbeam"] = "solarbeam";
    Farms["solarbeam2"] = "solarbeam2";
    Farms["thorus"] = "thorus";
    Farms["tetuswap"] = "tetuswap";
    Farms["solidex"] = "solidex";
    Farms["solidexB"] = "solidexB";
    Farms["solidexUSDC"] = "solidexUSDC";
    Farms["solidexUSDCB"] = "solidexUSDCB";
    Farms["oxdao"] = "oxdao";
    Farms["fenix"] = "fenix";
    Farms["fenixStable"] = "fenixStable";
    Farms["thruster"] = "thruster";
    Farms["aerodrome"] = "aerodrome";
    Farms["aeroStable"] = "aeroStable";
    Farms["aeroStable1"] = "aeroStable1";
    Farms["scaleStable"] = "scaleStable";
    Farms["merchantmoe"] = "merchantmoe";
    Farms["tokan"] = "tokan";
    Farms["tokan1"] = "tokan1";
    Farms["tokanStable"] = "tokanStable";
    Farms["nileStable"] = "nileStable";
    Farms["equalizerStable"] = "equalizerStable";
    Farms["velodrome"] = "velodrome";
    Farms["alien"] = "alien";
})(Farms = exports.Farms || (exports.Farms = {}));
exports.hrFarms = {
    [Farms.quickswapOld]: 'QuickSwap',
    [Farms.quickswap]: 'QuickSwap',
    [Farms.quickswapDual]: 'QuickSwap',
    [Farms.satin]: 'Satin',
    [Farms.pearl]: 'Pearl',
    [Farms.pearlStable]: 'Pearl Stable',
    [Farms.sushiswap]: 'SushiSwap',
    [Farms.arbinyan]: 'ArbyNYAN',
    [Farms.swapr]: 'Swapr',
    [Farms.swapfish]: 'SwapFish',
    [Farms.zyberswap]: 'ZyberSwap',
    [Farms.arbidex]: 'Arbidex',
    [Farms.solidlizard]: 'SolidLizard',
    [Farms.ramses]: 'Ramses',
    [Farms.auragi]: 'Auragi',
    [Farms.chronos]: 'Chronos',
    [Farms.solunea]: 'Solunea',
    [Farms.velocimeter]: 'Velocimeter',
    [Farms.velocore]: 'Velocore',
    [Farms.draculafi]: 'DraculaFi',
    [Farms.vesync]: 'VeSync',
    [Farms.radiant]: 'Radiant',
    [Farms.plutusDao]: 'Plutus DAO',
    [Farms.pangolin]: 'Pangolin',
    [Farms.pangolinV2]: 'Pangolin',
    [Farms.traderJoeV2]: 'TraderJoe',
    [Farms.traderJoeV3]: 'TraderJoe',
    [Farms.traderJoeV4]: 'TraderJoe',
    [Farms.flair]: 'Flair',
    [Farms.glacier]: 'Glacier',
    [Farms.solarbeam]: 'Solarbeam',
    [Farms.solarbeam2]: 'Solarbeam',
    [Farms.thorus]: 'Thorus',
    [Farms.tetuswap]: 'TetuSwap',
    [Farms.solidex]: 'Solidex',
    [Farms.solidexB]: 'Solidex',
    [Farms.solidexUSDC]: 'Solidex',
    [Farms.solidexUSDCB]: 'Solidex',
    [Farms.oxdao]: '0xDAO',
    [Farms.fenix]: 'fenix',
    [Farms.fenixStable]: 'Fenix Stable',
    [Farms.aerodrome]: 'Aerodrome',
    [Farms.aeroStable]: 'Aerodrome Stable',
    [Farms.aeroStable1]: 'Aerodrome Stable',
    [Farms.scaleStable]: 'Scale Stable',
    [Farms.tokan]: 'Tokan',
    [Farms.tokan1]: 'Tokan',
    [Farms.tokanStable]: 'Tokan Stable',
    [Farms.nileStable]: 'Nile Stable',
    [Farms.equalizerStable]: 'Equalizer Stable',
    [Farms.velodrome]: 'Velodrome',
    [Farms.alien]: 'AlienBase',
};
exports.STAKED_LP_FACTORY = {
    [types_1.Networks.Ropsten]: {},
    [types_1.Networks.Mainnet]: {},
    [types_1.Networks.Polygon]: {
        [Farms.quickswapOld]: '0xF47B652cDE9b30D6aDd0b13027Bb7AD2F7AF04f4',
        [Farms.quickswap]: '0x846019FB6f136fC98b80e527C3d34F39D16a38c4',
        [Farms.quickswapDual]: '0xC4505Cc6125d61E2A352ce5cf2129f2fb19259a8',
        [Farms.satin]: '0xCaF3Fb1b03F1D71A110167327f5106bE82beE209',
        [Farms.pearl]: '0xb07c75e3db03eb69f047b92274019912014ba78e',
        [Farms.pearlStable]: '0xFB8Bd40C0a13D141b26eE190Ca87991Ec54932E9',
        [Farms.sushiswap]: '0xcb30A66e72Ed90D1b34f78fc0655895FC28bB6CF',
        [Farms.tetuswap]: '0x8E45622663Bb01dc285B4F51Eb8F9FE4fa7b5899',
    },
    [types_1.Networks.Arbitrum]: {
        [Farms.arbinyan]: '0x6659a9c5cD313974343E30b4fDfFD95bD4b4dCd2',
        [Farms.sushiswap]: '0x270250F59C1ffA06C9e3234D528858Ff59aFCE68',
        [Farms.swapr]: '0x5643C3aCEC0D4970a385fb9Cc1555bec1d912bb8',
        //[Farms.swapfish]: '0xcDAeC65495Fa5c0545c5a405224214e3594f30d8',
        [Farms.swapfish]: '0x3bE7B59Ab6558845FfA1f026Dff40b305dd47b37',
        [Farms.zyberswap]: '0xBCE93e2D822CfDD70F106e32FCB266457cece45F',
        [Farms.arbidex]: '0x02f5ccD72351bbc4463A9a4b78708532a6BaDFef',
        [Farms.solidlizard]: '0x30d7ef0d94b43BFa4Ff5935DBC608D7fc0116BB7',
        [Farms.ramses]: '0x78a2251F1AAEaA8Fc1EaFcC379663cCa3F894708',
        [Farms.auragi]: '0x268bb0220aB61Abd9BD42C5Db49470bb3E6B0b2F',
        [Farms.chronos]: '0x111eEEb6bfAb9e8d0E87E45DB15031d89846e5d7',
        [Farms.solunea]: '0xf540E9C05ea1b54e310644Fc48E491d365bf86ba',
        [Farms.radiant]: '0x4aE11dC7D7e70eE16d7eaE32851302e55f6CA85e',
        [Farms.plutusDao]: '0x4dC48B93855F42cCcc54f65615AeF6FFC12EC1DF',
    },
    [types_1.Networks.Avalanche]: {
        [Farms.pangolin]: '0xBB92270716C8c424849F17cCc12F4F24AD4064D6',
        [Farms.pangolinV2]: '0xC596f6455054D8cdDE627096bE671e377791E295',
        [Farms.traderJoeV2]: '0x16ED59ffbfbe62ebA9a69a304D38901F86461282',
        [Farms.traderJoeV3]: '0x58Fde5bdB2C6Bd828Bc41c12a68189C7cd93dCE2',
        [Farms.traderJoeV4]: '0xbc1bb900e34adbb99957672361433c6ad62a0cac',
        [Farms.thorus]: '0x9141B3d02443a84793794f661Ae1e6607A03A201',
        [Farms.flair]: '0x30d7ef0d94b43BFa4Ff5935DBC608D7fc0116BB7',
        [Farms.glacier]: '0x7EB705bC12f488af3310d8166D3C577ACDBC619c',
    },
    [types_1.Networks.Moonriver]: {
        [Farms.sushiswap]: '0xBB92270716C8c424849F17cCc12F4F24AD4064D6',
        [Farms.solarbeam]: '0x95887654d8646c26fab33f344576e2e74b211256',
        [Farms.solarbeam2]: '0x23bdECdB7073D5f899708f33FCaFff787b81e287',
    },
    [types_1.Networks.Aurora]: {},
    [types_1.Networks.Cronos]: {},
    [types_1.Networks.Fantom]: {
        [Farms.solidex]: '0x95887654d8646C26fAb33F344576E2E74b211256',
        [Farms.solidexB]: '0x8610Dc1912a55761a713D827a1a1ad131bE8f579',
        [Farms.solidexUSDC]: '0xF14f98E6F34C12Bd74fcEAC1668aF749fc269cFf',
        [Farms.solidexUSDCB]: '0x9B1434a02Ee86302d463bB6B365EbdFAc56e067A',
        [Farms.oxdao]: '0xB83D21F60B73B21506c69DEcdBcF7Ab5AB737eB2',
    },
    [types_1.Networks.Canto]: {
        [Farms.velocimeter]: '0x1c813cDd6dAecE2CB83C52F0798504e42816E9C5',
    },
    [types_1.Networks.ZksyncEra]: {
        [Farms.velocore]: '0x36BbDb0DEA4Aa211Dd76dF0a3201c89FD530851b',
        [Farms.draculafi]: '0x589a63C2242c8E60cdACF6802AB04a721bA6049d',
        [Farms.vesync]: '0xCF3CAD85885254CBD445d6511c502Da095863f11',
    },
    [types_1.Networks.Blast]: {
        [Farms.fenix]: '0x29C714621152E607ea9768be05F8A96d9e41d62f',
        [Farms.fenixStable]: '0x77AB0B61E2994Dd5c62E578E23E409681E3bA42f',
    },
    [types_1.Networks.Harmony]: {},
    [types_1.Networks.Moonbeam]: {},
    [types_1.Networks.Sxnetwork]: {},
    [types_1.Networks.Base]: {
        [Farms.alien]: '0xA33366eeb5850535ed7cb52d4f631B19315fbc63',
        [Farms.aerodrome]: '0x2a32215Ba106039f5A96b6366338BDb9FB0b62E8',
        [Farms.aeroStable]: '0x8f50a6d5ea6715f878E2984569975e8875eeBafB',
        [Farms.aeroStable1]: '0x9111b8D7Cc1a676A70015BEA3A3a9968A44C52c3',
        [Farms.scaleStable]: '0xcCaF24B406A1733F626E3848Aa794cF79F6E33d4',
    },
    [types_1.Networks.Mantle]: {
        [Farms.merchantmoe]: '0x49bfE341232caE3CCB55ab99b11631CDE0AC9289',
    },
    [types_1.Networks.Scroll]: {
        [Farms.tokan]: '0x074568F090e93194289c2C2BF285eE7f60b485a9',
        [Farms.tokan1]: '0x3e35933C468ECEca9748DD1C5FADeFfe64158777',
        [Farms.tokanStable]: '0x6c041ff2d25310a2751C57555265F2364CaCA195',
    },
    [types_1.Networks.Optimism]: {
        [Farms.velodrome]: '0x47183bB55AD0F891887E099Cec3570d3C667cD00',
    },
    [types_1.Networks.Real]: {
        [Farms.pearl]: '0x2B965fDf04f9e9bEEf1659464Ef3A0094A68D923',
        [Farms.pearlStable]: '0x28E22D8c807b6E6c0ECa4373fC3B9920453cEEEe',
    },
    [types_1.Networks.Sonic]: {
        [Farms.equalizerStable]: '0x0E5F23675aBAB707D9f17da2EE883a77E13FE70f',
    },
    [types_1.Networks.Linea]: {
        [Farms.nileStable]: '0xB037874dE77E7b4505261301d2F3CE2fb9036cA7',
    }
};
function getFarmByStakedLPFactory(network, address) {
    if (!address)
        return null;
    for (const farm of Object.keys(Farms)) {
        if (exports.STAKED_LP_FACTORY[network][farm] &&
            address.toLowerCase() == exports.STAKED_LP_FACTORY[network][farm].toLowerCase())
            return farm;
    }
    return null;
}
exports.getFarmByStakedLPFactory = getFarmByStakedLPFactory;
